// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"3691defb","167":"f8479d06","427":"cba46160","542":"ee91bfec","592":"7f08726a"}[chunkId] + ".chunk.js";
};